import React, { useContext, useEffect, useState } from 'react';
import IMAGE from './Assets/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios'
import { toast } from 'react-toastify'
import UserContext from './Context/UserContext';





const Login = () => {
  const [email, setEmail] = useState('bryan@plsprint.com');
  const [pass, setPass] = useState('Mybae');
  const [remember, setRemember] = useState(false);
  const [newpassneeded, setNewpassneeded] = useState(false);
  const [newpass, setNewpass] = useState('');
  const [newconfirm, setNewconfirm] = useState('');
  const [submitbutton, setSubmitbutton] = useState(false);

const {login } = useContext(UserContext)

  const nav = useNavigate()

  // Handle remember checkbox change and update localStorage
  const handleRememberChange = (e) => {
    const isChecked = e.target.checked;
    setRemember(isChecked);
    if (isChecked) {
      localStorage.setItem('remember', 'true');
      localStorage.setItem('email', email);
    } else {
      localStorage.removeItem('remember');
      localStorage.removeItem('email');
    }
  };




  // Handle form submission
  const handleSubmit = async(e) => {
    e.preventDefault();
    console.log(email)
        console.log(pass)
login(email,pass)
  };

  return (
    <>


      <div className="relative w-2/4 flex justify-start items-start h-[90vh] mx-auto pt-[75px] flex-col">
        <div className="w-full flex items-center justify-center">
          <img src={IMAGE} width="50%" alt="PLS Print Logo" />
        </div>

        <section className="bg-gray-50 dark:bg-gray-900 border-grey border-1 mx-auto mt-[25px]">
          <div className="flex flex-col items-center justify-center px-6 py-8">
            <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
              <div className="px-6 space-y-4 md:space-y-4 sm:p-6">
                <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  Sign in to your account
                </h1>
                <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left"
                    >
                      Your email
                    </label>
                    <input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      name="email"
                      id="email"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="name@company.com"
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="password"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white text-left"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      value={pass}
                      onChange={(e) => setPass(e.target.value)}
                      name="password"
                      id="password"
                      placeholder="••••••••"
                      className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          id="remember"
                          aria-describedby="remember"
                          type="checkbox"
                          className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-1 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                          checked={remember}
                          onChange={handleRememberChange}
                        />
                      </div>


                      <div className="ml-3 text-sm ">
                        <label htmlFor="remember" className="text-gray-500">
                          Remember me
                        </label>
                      </div>
                    </div>
                  </div>
                 
                  <button
                    type="submit"
                    className={
  submitbutton ?  "w-full text-white bg-gray-600 bg-opacity-10 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800":
                    "w-full text-white bg-blue-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"}
                   
                  >
                    Sign in
                  </button>
                  <div className="m-0 p-0 mt-[20px] text-left">
                    Forgot your password?{' '}
                    <Link className="text-blue-700">Set up a new one</Link>
                  </div>
                  <div className="m-0 p-0 text-left">
                    Don't have an account yet?{' '}
                    <Link to="/signup" className="text-blue-700">Register one here</Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Login;